import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import PickingCriteriaProcessActions from '../../Stores/PickingCriteriaProcess/Actions';

import PickingCriteriaList01Table from '../PickingCriteriaList01/PickingCriteriaList01Table';
import PickingCriteriaExcel01Table from '../PickingCriteriaExcel01/PickingCriteriaExcel01Table';

const { TabPane } = Tabs;

class PickingCriteriaProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchPickingCriteriaProcess } = this.props;
    if (curSiteFlowId > 0) {
      fetchPickingCriteriaProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchPickingCriteriaProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchPickingCriteriaProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/pickingCriteriaProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'PICKING_CRITERIA_LIST_01' && (
          <PickingCriteriaList01Table match={match} />
        )}
        {match.params.proc_type === 'PICKING_CRITERIA_EXCEL_01' && (
          <PickingCriteriaExcel01Table match={match} />
        )}
      </Card>
    );
  }
}

PickingCriteriaProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchPickingCriteriaProcess: PropTypes.func
};

PickingCriteriaProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchPickingCriteriaProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.pickingCriteriaProcess.process,
  processIsLoading: state.pickingCriteriaProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchPickingCriteriaProcess: () =>
    dispatch(PickingCriteriaProcessActions.pickingCriteriaProcessFetchPickingCriteriaProcess())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(PickingCriteriaProcessScreen));
